import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";
import { Options } from "./SelectOptions";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    salutation: string,
    academicTitle: string,
    entranceDate: Date | null,
    salaryRequest: number | null,
    workExperience: string,
    schoolEducation: string,
    schoolGrade: number | null,
    otherInformation: string,
    vocationalTraining1: string,
    vocationalTrainingGrade1: number | null,
    vocationalTraining2: string,
    vocationalTrainingGrade2: number | null,
    vocationalTraining3: string,
    vocationalTrainingGrade3: number | null,
    study1: string,
    study2: string,
    study3: string,
    academicDegree1: string,
    academicDegree2: string,
    academicDegree3: string,
    finalYearOfStudy1: Date | null,
    finalYearOfStudy2: Date | null,
    finalYearOfStudy3: Date | null,
    studyGrade1: number | null,
    studyGrade2: number | null,
    studyGrade3: number | null,
    applicationAs: string,
    preferredLocation1: string,
    preferredLocation2: string,
    applicationFor: string,
    fieldOfActivity1: string,
    fieldOfActivity2: string,
    abiturnote: number | null,
    studyStatus: string,
    university: string,
    stateExamTotalScore: number | null,
    stateExamStatePart: number | null,
    stateExamUniversityPart: number | null,
    secondStateExam: number | null,
    doctorate: string,
    professorialChair: string,
    masterOfLaws: string,
    currentSemester: number | null,
    gradePublicLaw: string,
    gradeCriminalLaw: string,
    gradeCivilLaw: string,
    otherGrades: string,

    grant1: string,
    grant2: string,
    grant3: string,
    grant4: string,
    grant5: string,

    nonAcademicCommitment: string,

    fieldsOfActivity: CheckboxField[],
    otherFieldsOfActivity: string,

    // Zusatzdokumente
    coveringLetterFile: File | undefined,
    certificatesFile: File | undefined,
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string){
        this.displayName = displayName;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    salutation: string = "";
    academicTitle: string = "";
    entranceDate: Date | null = null;
    salaryRequest: number | null = null;
    workExperience: string = "";
    schoolEducation: string = "";
    schoolGrade: number | null = null;
    otherInformation: string = "";
    vocationalTraining1: string = "";
    vocationalTrainingGrade1: number | null = null;
    vocationalTraining2: string = "";
    vocationalTrainingGrade2: number | null = null;
    vocationalTraining3: string = "";
    vocationalTrainingGrade3: number | null = null;
    study1: string = "";
    study2: string = "";
    study3: string = "";
    academicDegree1: string = "";
    academicDegree2: string = "";
    academicDegree3: string = "";
    finalYearOfStudy1: Date | null = null;
    finalYearOfStudy2: Date | null = null;
    finalYearOfStudy3: Date | null = null;
    studyGrade1: number | null = null;
    studyGrade2: number | null = null;
    studyGrade3: number | null = null;
    coveringLetterFile: File | undefined = undefined;
    certificatesFile: File | undefined = undefined;
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    name: string = "";
    email: string = "";
    applicationAs: string = "";
    preferredLocation1: string = "";
    preferredLocation2: string = "";
    applicationFor: string = "";
    fieldOfActivity1: string = "";
    fieldOfActivity2: string = "";
    studyStatus: string = "";
    abiturnote: number | null = null;
    university: string = "";
    stateExamTotalScore: number | null = null;
    stateExamStatePart: number | null = null;
    stateExamUniversityPart: number | null = null;
    secondStateExam: number | null = null;
    doctorate: string = "";
    professorialChair: string = "";
    masterOfLaws: string = "";
    currentSemester: number | null = null;
    gradePublicLaw: string = "";
    gradeCriminalLaw: string = "";
    gradeCivilLaw: string = "";
    otherGrades: string = "";
    
    grant1: string = "";
    grant2: string = "";
    grant3: string = "";
    grant4: string = "";
    grant5: string = "";

    nonAcademicCommitment: string = "";

    fieldsOfActivity: CheckboxField[] = Options.FieldOfActivity.map((field) => {
        return new CheckboxField(field);
    });
    otherFieldsOfActivity: string = "";

    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "salutation", value: this.salutation },
            { name: "academicTitle", value: this.academicTitle },
            { name: "entranceDate", value: this.entranceDate?.toString() ?? "" },
            { name: "salaryRequest", value: this.salaryRequest?.toString() ?? "" },
            { name: "workExperience", value: this.workExperience },
            { name: "schoolEducation", value: this.schoolEducation },
            { name: "schoolGrade", value: this.gradeAsString(this.schoolGrade) },
            { name: "otherInformation", value: this.otherInformation },
            { name: "vocationalTraining1", value: this.vocationalTraining1 },
            { name: "vocationalTrainingGrade1", value: this.gradeAsString(this.vocationalTrainingGrade1) },
            { name: "vocationalTraining2", value: this.vocationalTraining2 },
            { name: "vocationalTrainingGrade2", value: this.gradeAsString(this.vocationalTrainingGrade2) },
            { name: "vocationalTraining3", value: this.vocationalTraining3 },
            { name: "vocationalTrainingGrade3", value: this.gradeAsString(this.vocationalTrainingGrade3) },
            { name: "study1", value: this.study1 },
            { name: "study2", value: this.study2 },
            { name: "study3", value: this.study3 },
            { name: "academicDegree1", value: this.academicDegree1 },
            { name: "academicDegree2", value: this.academicDegree2 },
            { name: "academicDegree3", value: this.academicDegree3 },
            { name: "finalYearOfStudy1", value: this.finalYearOfStudy1?.toString() ?? "" },
            { name: "finalYearOfStudy2", value: this.finalYearOfStudy2?.toString() ?? "" },
            { name: "finalYearOfStudy3", value: this.finalYearOfStudy3?.toString() ?? "" },
            { name: "studyGrade1", value: this.gradeAsString(this.studyGrade1) },
            { name: "studyGrade2", value: this.gradeAsString(this.studyGrade2) },
            { name: "studyGrade3", value: this.gradeAsString(this.studyGrade3) },
            { name: "applicationAs", value: this.applicationAs },
            { name: "preferredLocation1", value: this.preferredLocation1 },
            { name: "preferredLocation2", value: this.preferredLocation2 },
            { name: "applicationFor", value: this.applicationFor },
            { name: "fieldOfActivity1", value: this.fieldOfActivity1 },
            { name: "fieldOfActivity2", value: this.fieldOfActivity2 },
            { name: "studyStatus", value: this.studyStatus },
            { name: "abiturnote", value: this.gradeAsString(this.abiturnote) },
            { name: "university", value: this.university },
            { name: "stateExamTotalScore", value: this.gradeAsString(this.stateExamTotalScore) },
            { name: "stateExamStatePart", value: this.gradeAsString(this.stateExamStatePart) },
            { name: "stateExamUniversityPart", value: this.gradeAsString(this.stateExamUniversityPart) },
            { name: "secondStateExam", value: this.gradeAsString(this.secondStateExam) },
            { name: "doctorate", value: this.doctorate },
            { name: "professorialChair", value: this.professorialChair },
            { name: "masterOfLaws", value: this.masterOfLaws },
            { name: "currentSemester", value: this.currentSemester?.toString() ?? "" },
            { name: "gradePublicLaw", value: this.gradePublicLaw },
            { name: "gradeCriminalLaw", value: this.gradeCriminalLaw },
            { name: "gradeCivilLaw", value: this.gradeCivilLaw },
            { name: "otherGrades", value: this.otherGrades },
        
            { name: "grant1", value: this.grant1 },
            { name: "grant2", value: this.grant2 },
            { name: "grant3", value: this.grant3 },
            { name: "grant4", value: this.grant4 },
            { name: "grant5", value: this.grant5 },

            { name: "nonAcademicCommitment", value: this.nonAcademicCommitment },
            { name: "fieldsOfActivity", value: this.fieldsOfActivity.filter((field) => field.value === true).map((field) => field.displayName).join(';')},
            { name: "otherFieldsOfActivity", value: this.otherFieldsOfActivity},
        );

        return application;
    }

    private gradeAsString(value: number | null): string {
        return value?.toLocaleString(undefined, { minimumFractionDigits: 1 }) ?? "";
    }
}
